import "../styles/enterprise-semester.css";

const images = Array.from({ length: 30 }, (_, i) => {
  const num = String(i + 1).padStart(2, "0");
  return {
    id: i + 1,
    src: `/images/enterprise-semester-design24/enterprise-semester-${num}.jpg`,
    alt: `Enterprise Semester ${num}`,
  };
});

const EnterpriseSemesterSection = () => {
  return (
    <div className="enterprise-semester__bg">
      <div className="enterprise-semester">
        <div className="enterprise-semester__wrapper">
          <h2 className="enterprise-semester__title">
            HỌC KỲ THỰC CHIẾN DOANH NGHIỆP
            <span className="line"></span>
          </h2>
          <p className="enterprise-semester__subtitle">
            Sinh viên các trường Đại học – Cao đẳng tham dự tại Học viện
            Design24
          </p>
        </div>

        <div className="enterprise-semester__list">
          {images.map((img) => (
            <div
              key={img.id}
              className="enterprise-semester__item"
            >
              <div className="enterprise-semester__item-content">
                <img
                  src={img.src}
                  alt={img.alt}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EnterpriseSemesterSection;
